import script from "./TextCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextCell.vue?vue&type=script&setup=true&lang=ts"

import "./TextCell.vue?vue&type=style&index=0&id=45d1a3d3&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d1a3d3"]])

export default __exports__